import { render, staticRenderFns } from "./AddDocumentInline.vue?vue&type=template&id=64ec681e"
import script from "./AddDocumentInline.vue?vue&type=script&lang=js"
export * from "./AddDocumentInline.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentInline.vue?vue&type=style&index=0&id=64ec681e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports